import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';
import { NgxCurrencyConfig } from 'ngx-currency';

interface InputProps extends FormlyFieldProps {
  mask?: string;
  thousandSeparator?: string;
  autocomplete?: string;
  clearOnFocus: 'zero' | 'always';
  currencyOptions: NgxCurrencyConfig;
}

@Component({
    selector: 'lockton-apps-input-field-type',
    templateUrl: './input-field-type.component.html',
    styleUrls: ['./input-field-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InputFieldTypeComponent extends FieldType<
  FieldTypeConfig<InputProps>
> {
  get type() {
    return this.props.type || 'text';
  }
}
